export default "__VITE_ASSET__9894b4c7__"